module.exports = __webpack_public_path__ + "img/airtke_help.03d00f7f.jpg";